import { RatingType } from '@empathy/survey/base';

import { ExtendedQuestionType } from './notepad-question-type.constant';

export class NotepadModel {
  programmerNotes: string;
  questions: NotepadQuestion[];
}

export class NotepadQuestion {
  questionId: string;
  questionText?: string;
  mandatoryInd: boolean;
  questionType: ExtendedQuestionType;
  options?: string[];
  ranks?: string[];
  cards?: string[];
  otherOptionInd: boolean;
  randomizeOptionsInd: boolean;
  instructions: string;
  programmerNotes: string;
  ratingType?: RatingType;
  noneOptionInd: boolean;
}
